module.exports = __webpack_public_path__ + "img/TailWing_Overview-TW_2.1b9058e2.jpg";